<template>
    <el-dialog :visible="visible" width="500px" @close="handleClose" class="small-edit-dialog">
        <div class="title">{{ form.sno == null ? "新增" : "編輯" }}專案類型</div>
        <el-form label-width="120px" :model="form" label-position="top" @submit.prevent.native="handleSubmit">
            <el-form-item label="名稱">
                <el-input v-model="form.pjcaT_NAM" ref="nameInput" :show-word-limit="true" maxlength="20" />
            </el-form-item>
        </el-form>
        <span class=" main-action">
            <el-button type="primary" class="primary-action" @click="handleSubmit" :loading="isLoading">{{ form.sno == null ? "新增" : "儲存" }}</el-button>
            <el-button type="" @click="handleClose">取消</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        typeData: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            isLoading: false,
            form: {
                sno: null,
                pjcaT_NAM: '',
            },
        };
    },
    watch: {
        typeData(val) {
            if (val) {
                this.form.sno = val.sno;
                this.form.pjcaT_NAM = val.pjcaT_NAM;
            }
        },
        visible(val) {
            if (val) {
                setTimeout(() => {
                    this.$refs.nameInput.focus();
                }, 100);
            }
        },
    },

    methods: {
        handleClose(refresh = false, newSno = null) {
            this.$emit('close', { refresh, newSno });
            setTimeout(() => {
                this.form.sno = null;
                this.form.pjcaT_NAM = '';
            }, 500);
        },
        async handleSubmit() {
            let url = '';
            if (this.form.sno) url = 'ProjectCategoryManagementPage/UpdateName';
            else url = 'ProjectCategoryManagementPage/Add';
            this.isLoading = true;
            try {
                const resp = await this.$api({
                    url,
                    method: 'POST',
                    data: this.form,
                });
                this.handleClose(true, resp.data.sno);
            } catch (error) {
                console.log(error);
            }
            this.isLoading = false;
        },
    },
};
</script>
